export default {
	success: "Success!",
	error: "Error!",
	errorMessage: "Some error occurred, please try later.",
};
